// extracted by mini-css-extract-plugin
export default {"wrapper":"JS-z","availablePromoMessagesLabel":"KS-z","promoMessageList":"LS-z","promoMessage":"MS-z","appliedPromoMessage":"NS-z","promoMessageAmount":"OS-z"};